import { useQuery, gql } from '@apollo/client';

const GET_DISCOVER_SPORTS = gql`
  query DiscoverSports($input: DiscoverInput!) {
    discoverSports(input: $input) {
      sportNames
    }
  }
`;

const useDiscoverSports = cityName => {
  const { data, loading, error } = useQuery(GET_DISCOVER_SPORTS, {
    skip: !cityName,
    variables: {
      input: {
        cityName,
      },
    },
  });

  const { discoverSports } = data || {};
  const sportNames = discoverSports?.sportNames || [];

  return { sportNames, loading, error };
};

export default useDiscoverSports;
